module.exports = __webpack_public_path__ + "img/home-premium-2.2f395379.png";